<template>
    <div
        ref="td"
        class="form-table__td tabable"
        v-on="on"
        :tabindex="tabindex"
        :style="styleObject"
    >
        <slot></slot>
    </div>
</template>

<script>

import FormTableComponentBase
    from "./mixins/FormTableComponentBase";

/**
 * 컴포넌트 테이블에 대한 기본 키 입력 바인딩, 기본 레이아웃 등을 지원하는 컴포넌트입니다.
 */
export default {
    name: "FormTableComponentTd",
    extends: FormTableComponentBase,
    computed: {
    },
    mounted() {
        // key 입력 작업을 위한 td, input 에 대한 keyManager 를 생성합니다.
        // input, td 에 대한 모든 이벤트 작업을 수행합니다.
        // td 엘리먼트 지정후 input form 에 form-table__input 클래스를 부여할 경우 input 에 대한
        // 이벤트 리스너를 자동으로 등록해 줍니다.
        this.initElement(this.$refs.td);
    },
    methods: {

    },
}
</script>

<style scoped>
    .form-table__td {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        overflow: hidden;
    }
</style>